import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=53eb6495&scoped=true"
import script from "./TagManager.vue?vue&type=script&lang=ts"
export * from "./TagManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb6495",
  null
  
)

export default component.exports